<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Mention Légale" />
            <MentionLegale />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import MentionLegale from '../MentionLegale/MentionLegale'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'MentionLegalePage',
    components: {
        NavBar,
        PageTitle,
        MentionLegale,
        FooterComp,
    }
}
</script>